import React from 'react';
import { motion } from 'framer-motion';
import './GlobalLoader.css';

const GlobalLoader = () => (
  <div className="global-loader-backdrop">
    <motion.div
      className="global-loader-spinner"
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
    />
  </div>
);

export default GlobalLoader;
